import * as React from "react";
import { IParagraphSupportTilesProps } from "./ParagraphSupportTilesProps";
import { Container } from "./ParagraphSupportTilesHelpers";
import { graphql } from "gatsby";
import SupportTiles from "../../common/SupportTiles/SupportTiles";

const ParagraphSupportTiles: React.FC<IParagraphSupportTilesProps> = (
  props
) => {
  return (
    <Container>
      <SupportTiles {...props} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphSupportTiles on paragraph__support_tiles {
    id
    name
    relationships {
      field_tiles {
        field_links {
          title
          url
        }
        field_title
        field_icon_name
      }
    }
  }
`;
export default ParagraphSupportTiles;
